import { create } from "zustand";
import type { DetailType } from "#shared/schemas/entityDetail.ts";

export interface DetailTarget {
  type: DetailType;
  id: string;
}

interface DetailState {
  target: DetailTarget | null;
  /** Point the sheet at an entity. Grid focus does this for tracks. */
  setTarget: (target: DetailTarget | null) => void;
}

/**
 * Which entity the detail sheet describes. Ephemeral UI state, so it stays here
 * rather than being duplicated out of TanStack Query.
 */
export const useDetailStore = create<DetailState>((set) => ({
  target: null,
  setTarget: (target) =>
    set((state) => {
      const same =
        state.target !== null &&
        target !== null &&
        state.target.type === target.type &&
        state.target.id === target.id;
      return same ? state : { target };
    }),
}));
